// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__24n68","title":"InfoRow_title__2xZmX"};